import { useCallback, useState } from "react";
import moment from "moment";
import { FiltroRelatorioBalancoFinanceiro } from "core/features/relatorios/typings";

function useFiltroRelatorioBalancoFinanceiro() {
  const [filtro, setFiltro] = useState<FiltroRelatorioBalancoFinanceiro>({
    search: "",
    contaBancariaIds: undefined,
    contaCategoriaIds: undefined,
    dataFim: moment().format("YYYY-MM-DD"),
    dataInicio: moment().startOf("month").format("YYYY-MM-DD"),
  });

  const onChangeFiltro = useCallback(
    (_filtro: Partial<FiltroRelatorioBalancoFinanceiro>) => {
      setFiltro((state) => ({ ...state, ..._filtro }));
    },
    []
  );

  return {
    filtro,
    setFiltro,
    onChangeFiltro,
  };
}

export default useFiltroRelatorioBalancoFinanceiro;
